export default "__VITE_ASSET__9f0110a5__"